"use client";

import React from "react";
import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Chip,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Shield, Description, Person, MenuBook } from "@mui/icons-material";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";

const OppoSupportPage = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({txt:"",type:true});
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return; // Prevent snackbar from closing on clickaway
    }
    setOpen(false);
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    subject:""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

function handleValidation(){
    const {name,email,message,subject}=formData
    if(name===''||email===''||message===''||subject==='') {
        setOpen(true)
        setMessage({txt:'Fields are required',type:false})
        return true
    }
    return false
}

  const handleSubmit = (e) => {
    e.preventDefault();
    if(handleValidation()) return
    setLoading(true);
    axios
      .post(base_url + "/customer-support", formData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        setFormData({
            name: "",
            email: "",
            message: "",
            subject:""
          })
        setOpen(true)
        setMessage({txt:'Your query has been submitted successfully',type:true})
        setLoading(false);
      })
      .catch((err) => {
        setOpen(true)
        setMessage({txt:'Some error occured',type:false})
        setLoading(false);
      });
    console.log("Form submitted:", formData);
    // Handle form submission here
  };

  const services = [
    {
      icon: <Shield sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: " Visa Application Services",
      description:
        "Explore our services: Student Visa, Work Visa, Visitor Visa, and more.",
    },
    {
      icon: <Description sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: " Check Application Status",
      description: "Track the status of your visa application and updates.",
    },
    {
      icon: <Person sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: ". Find Our Offices Near You",
      description:
        "“Locate our visa consultancy branches or book a virtual consultation",
    },
    {
      icon: <MenuBook sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Visa Application Guide",
      description: "Learn how to prepare and apply for your visa step-by-step",
    },
  ];

  const quickActions = [
    "Visa Consultancy Adaptation",
    "Visa Resources & Tools",
    "Document Preparation Services",
    "Interactive Visa Quiz",
    "Save & Resume Applications",
    "Expert Guidance & Consultation",
  ];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      {/* Hero Section */}
      <Box
        sx={{
          height: "80vh",
          backgroundImage: "url(/banner.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <Box textAlign="center" color="white" mb={4}>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "2rem", md: "3rem" },
                textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              Welcome to Connect Overseas Support
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                opacity: 0.9,
                textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
              }}
            >
              Friendly, Convenient & Professional
            </Typography>
          </Box>

          {/* Contact Form */}
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 2,
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
            }}
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    variant="outlined"
                    required
                  />
                </Grid>
               
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    variant="outlined"
                    multiline
                    // rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    variant="outlined"
                    multiline
                    rows={3}
                    required
                  />
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center">
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    onClick={handleSubmit}
                    disabled={loading} // disables button while loading
                    sx={{
                      px: 6,
                      py: 1.5,
                      borderRadius: 3,
                      textTransform: "none",
                      fontSize: "1.1rem",
                      position: "relative",
                    }}
                  >
                    {/* Wrap content in a fixed-size box to preserve width */}
                    <span
                      style={{ visibility: loading ? "hidden" : "visible" }}
                    >
                      Submit
                    </span>

                    {loading && (
                      <CircularProgress
                        size={24}
                        color="inherit"
                        sx={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          marginTop: "-12px",
                          marginLeft: "-12px",
                        }}
                      />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>

          {/* Quick Actions */}
          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexWrap="wrap"
            gap={1}
          >
            {quickActions.map((action, index) => (
              <Chip
                key={index}
                label={action}
                variant="outlined"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  color: "#333",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                  },
                }}
              />
            ))}
          </Box>
        </Container>
      </Box>

      {/* Convenient Services Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#333" }}
          >
            Convenient Services
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ opacity: 0.8 }}>
            Easy access to your support services!
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  textAlign: "center",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: 4,
                  },
                  cursor: "pointer",
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box mb={2}>{service.icon}</Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Snackbar
        open={open}
        autoHideDuration={3000} // Snackbar disappears after 3 seconds
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={message.type?"success":'error'} sx={{ width: "100%" }}>
          {message.txt}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OppoSupportPage;
